/**
 * Created by linjianxi on 2016/10/27.
 */
import * as actions from './ations'
import * as getters from './getter'
import * as types from './mutation-type'
const state = {
  type: 1,
  data: {},
  statu: ''
}
const mutations = {
  [types.CHECKSWITCH] (state, data) {
    state.type = 1
    state.data = data
  },
  [types.GET_RECHARGE_STATUS] (state, data) {
    state.statu = data
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/setting/store.js